import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  iconMap  from "../untils/iconmap";
import { customIcons } from "../untils/custom_icons";

const RenderIcon = ({ icon, className = "text-4xl text-gray-800 mb-4" }) => {
  const FAIcon = iconMap[icon];
  const CustomIcon = customIcons[icon];

  if (FAIcon) {
    return <FontAwesomeIcon icon={FAIcon} className={className} />;
  } else if (CustomIcon) {
    // Render Custom SVG icon
    return <CustomIcon className={className} />;
  } else {
    // Fallback — default icon or placeholder
    return (
      <div
        className={`w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center ${className}`}
      >
        ❓
      </div>
    );
  }
};

export default RenderIcon;
